import React, { useRef, useEffect } from "react";
import styles from "./FreeTrialModal.module.css";

const FreeTrialModal = ({ onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleFreeTrial = () => {
    window.open('https://app.talent14.com/', '_blank');
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} ref={modalRef}>
        <button className={styles.closeButton} onClick={onClose}>
          ✕
        </button>
        
        <div className={styles.content}>
          <div className={styles.badge}>
            <span className={styles.badgeText}>🎉 ÜCRETSİZ</span>
          </div>
          
          <div className={styles.iconContainer}>
            <div className={styles.icon}>🚀</div>
            <div className={styles.sparkles}>✨</div>
          </div>
          
          <h2 className={styles.title}>
            HEMEN ÜCRETSİZ DENE!
          </h2>
          
          <p className={styles.description}>
            Yapay zeka destekli eğitim platformumuzu <strong>ücretsiz</strong> keşfet!
          </p>
          
          <ul className={styles.features}>
            <li className={styles.feature}>
              <span className={styles.checkIcon}>✓</span>
              <span>Kişiselleştirilmiş yol arkadaşı</span>
            </li>
            <li className={styles.feature}>
              <span className={styles.checkIcon}>✓</span>
              <span>Okul derslerine destek</span>
            </li>
            <li className={styles.feature}>
              <span className={styles.checkIcon}>✓</span>
              <span>Güvenli, etik ve ahlaklı yapay zeka</span>
            </li>
          </ul>
          
          <div className={styles.buttonGroup}>
            <button 
              className={styles.trialButton} 
              onClick={handleFreeTrial}
            >
              <span className={styles.buttonText}>Hemen Başla</span>
              <span className={styles.arrow}>→</span>
            </button>
          </div>
          
          <p className={styles.note}>
            Kredi kartı bilgisi gerektirmez
          </p>
        </div>
      </div>
    </div>
  );
};

export default FreeTrialModal;
